import { Button } from '@cian/ui-kit/button';
import { InlineText1 } from '@cian/ui-kit/typography';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './RequestDemandBanner.css';

export interface IRequestDemandBannerProps {
  title: string;
  text: string;
  buttonText: string;
  buttonAction: () => void;
  image: string;
  withoutBorders: boolean;
}

export const RequestDemandBanner: React.FC<IRequestDemandBannerProps> = ({
  title,
  text,
  buttonText,
  buttonAction,
  image,
  withoutBorders,
}) => (
  <div className={classNames(styles['root'], withoutBorders && styles['no-borders'])}>
    <div className={styles['content']}>
      <div className={styles['title']}>
        <InlineText1 fontWeight="bold">{title}</InlineText1>
      </div>
      <div className={styles['text']}>
        <InlineText1 color="black_100">{text}</InlineText1>
      </div>
      <div className={styles['action']}>
        <Button theme="fill_secondary" size="XS" onClick={buttonAction}>
          {buttonText}
        </Button>
      </div>
    </div>
    <div className={styles['image-wrapper']}>
      <img src={image} />
    </div>
  </div>
);

RequestDemandBanner.displayName = 'RequestDealBanner';
